var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjectdetectionOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1.5,
    width: 52,
    height: 53,
    rx: 6.5,
    fill: "#FF8027"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1.5,
    width: 52,
    height: 53,
    rx: 6.5,
    stroke: "#FF8027",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.7999 24.5333L41.2333 20.9667L31.4333 13.0667L28.0666 16.6667L24.6333 13L14.7666 20.9667L18.1999 24.5333L14.7666 28.1L18.4999 31.1167V35.3833L28.0333 43L37.5499 35.3833V31.0667L41.2333 28.1167L37.7999 24.5333ZM27.9999 30.0833L21.0666 24.5333L27.9999 19L34.9999 24.5333L27.9999 30.0833ZM36.3333 25.7667L38.4166 27.9333L31.6666 33.4667L29.4999 31.2833L36.3333 25.7667ZM31.6666 15.6167L38.5333 21.1333L36.3833 23.3333L29.4999 17.8L31.6666 15.6167ZM24.4833 15.5333L26.6666 17.7333L19.6166 23.3333L17.5333 21.1333L24.4833 15.5333ZM19.6166 25.7667L26.6666 31.3333L24.4666 33.5333L17.5333 27.9333L19.6166 25.7667ZM20.3833 32.6333L24.6333 36.0667L27.1333 33.4667V39.8833L20.4666 34.4833L20.3833 32.6333ZM35.6833 34.4833L29.0166 39.8167V33.4667L31.4499 36L35.6999 32.6667V34.5667L35.6833 34.4833Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectdetectionOrange);
export default __webpack_public_path__ + "static/media/Object detection Orange.48740105f2b1b57aee52e8907030ced4.svg";
export { ForwardRef as ReactComponent };